interface Size {
  max: number;
  min: number;
}

interface Dimension {
  height: Size;
  width: Size;
}

export const validateImageDimensions = (file: File, dimensions: Dimension) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = event => {
      const img = new Image();
      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;

        if (
          width >= dimensions.width.min &&
          width <= dimensions.width.max &&
          height >= dimensions.height.min &&
          height <= dimensions.height.max
        ) {
          resolve(true);
        } else {
          reject(`Invalid image dimensions.`);
        }
      };
      img.onerror = () => {
        reject(
          `The format is not acceptable. Check the format and upload again!`
        );
      };
      img.src = event.target.result.toString();
    };

    reader.onerror = () => {
      reject(
        `The format is not acceptable. Check the format and upload again!`
      );
    };

    reader.readAsDataURL(file);
  });

export const validateFileSize = (file: File) =>
  new Promise((resolve, reject) => {
    if (file.size > 2 * 1024 * 1024) {
      reject(`File size of the image you are trying to upload is too large.`);
      return;
    }

    resolve(true);
  });

export const validateMimeTypes = (file: File) =>
  new Promise((resolve, reject) => {
    const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
    if (!allowedExtensions.exec(file.name)) {
      reject(
        `The format is not acceptable. Check the format and upload again!`
      );
      return;
    }

    return resolve(true);
  });
